export const GLOBALSERVERREQUESTPENDINGSTATEMESSAGE =
  "Please wait! while processing your request";
